<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <rect x="3" y="4" width="18" height="16" rx="2"/>
        <path d="M3 9h18M9 9v11M15 9v11"/>
    </svg>
</template>
